import { useRef, useState } from "react";
import DropFieldHere from "../DropFieldHere";
import { useDrop } from "react-dnd";
import { useSelector, useDispatch } from "react-redux";
import { nanoid } from "@reduxjs/toolkit";
import {
  setLevel2Properties,
  updateLevel2Properties,
  getL1SheetProperty,
  getL2SheetProperty,
  setCommonFilters,
  getWorkbookProperty,
  removeLevel2PropertiesBynanoId,
  moveDroppedColumn,
} from "../../WorkbookSlice";
import FilterConfigComponent from "./DropzoneComponents/FilterConfigComp";
import MetricConfigComponent from "./DropzoneComponents/MetricsConfigComp";
import DateComponent from "./DropzoneComponents/DateComponent";
import NoformatModalDrop from "./DropzoneComponents/NoformatModalDrop";
import FilterFieldComp from "./DropzoneComponents/FilterFieldComp";
import DataConfigComp from "./DropzoneComponents/Date/DataConfigComp";
import AreaMapping from "../../../../components/VizComponents/MapWithArea/AreaMapping";
import Type_n_Select from "../Type_n_Select";
import DroppedData from "./DropzoneComponents/DroppedData";

const limitOptions = [
  { label: 10, value: 10 },
  { label: 50, value: 50 },
  { label: 100, value: 100 },
  { label: 250, value: 250 },
  { label: 500, value: 500 },
  { label: 1000, value: 1000 },
  { label: 5000, value: 5000 },
];

const DropZoneComp = ({
  ControllerProps,
  currentSheet,
  parentKey,
  dataSourceID,
  VizchartType,
}) => {
  const { Sheetid } = currentSheet;
  const {
    title,
    type,
    single,
    dataTypeAllowed,
    reduxKey,
    itemInArray,
    canEdit,
  } = ControllerProps;
  const dispatch = useDispatch();

  const requiredArray =
    useSelector((state) => {
      return getL2SheetProperty(state, Sheetid, parentKey, reduxKey);
    }) || [];

  const viztype = useSelector((state) => {
    return getL1SheetProperty(state, Sheetid, "VizType");
  });
  const customization = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "customization")
  );

  const droppedItemRef = useRef(null);
  const [filterConfigContent, setFilterConfigContent] = useState(null);
  const [MetricConfigContent, setMetricConfigContent] = useState(null);
  const [dateConfigContent, setDateConfigContent] = useState(null);
  const [noFormattModal, setNoFormattModal] = useState(false);
  // // console.log(canEdit);
  const [filterFieldModal, setFilterFieldModal] = useState(null);

  const dispatchItemToredux = (value) => {
    dispatch(
      setLevel2Properties({
        reduxKey,
        Sheetid,
        parentKey,
        value,
        itemInArray,
      })
    );
  };
  const dispatchCommonFilters = (value, operation) => {
    // console.log(value);
    dispatch(
      setCommonFilters({
        operation,
        value,
        Sheetid,
      })
    );
  };
  const dispatchUpdateItem = (value, index) => {
    // console.log(value);
    dispatch(
      updateLevel2Properties({
        reduxKey,
        Sheetid,
        parentKey,
        value,
        itemInArray,
        index: value.index === undefined ? index : value.index,
      })
    );
  };
  const handleClosePopup = () => {
    // console.log("all dropZone popups are closed");
    setFilterConfigContent(null);
    setMetricConfigContent(null);
    setDateConfigContent(null);
    setFilterFieldModal(null);
  };
  const rowLimit = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "query", "rowLimit")
  );
  const calculatedFields =
    useSelector((state) => getWorkbookProperty(state, "calculatedFields")) ||
    [];
  const handleSavePopupFilter = (updatedItem, alreadyExists) => {
    // console.log(updatedItem);
    const operation = alreadyExists ? "UPDATE" : "ADD";
    dispatchCommonFilters(updatedItem, operation);
    setFilterConfigContent(null);
  };
  const handleSavePopupMetric = (droppedItem, alreadyExists, index) => {
    // console.log(droppedItem);
    if (!alreadyExists) {
      dispatchItemToredux({ ...droppedItem });
    } else {
      dispatchUpdateItem({ ...droppedItem, index });
    }
    handleClosePopup();
  };
  const handleSavePopupDate = (droppedItem, alreadyExists, index) => {
    // console.log(droppedItem);
    if (!alreadyExists) {
      dispatchItemToredux(droppedItem);
    } else {
      dispatchUpdateItem({ ...droppedItem, index });
    }
    handleClosePopup();
  };
  const renderFilterConfigComponent = (droppedItem, a) => {
    setFilterConfigContent(
      <FilterConfigComponent
        {...{
          parentKey,
          reduxKey,
          Sheetid,
          droppedItem,
          handleClosePopup,
          handleSavePopupFilter,
          a,
          dataSourceID,
        }}
      />
    );
  };
  const renderDateConfigForFilters = (droppedItem) => {
    setFilterConfigContent(
      <DataConfigComp
        reduxKey={reduxKey}
        parentKey={parentKey}
        Sheetid={Sheetid}
        droppedItem={droppedItem}
        handleClosePopup={handleClosePopup}
        handleSavePopupFilter={handleSavePopupFilter}
      />
    );
  };
  const handleFilterFieldSave = (a, droppedItem) => {
    // console.log(a);
    // console.log(droppedItem);
    if (a !== "RelativeDate") {
      renderFilterConfigComponent(droppedItem, a);
    } else {
      renderDateConfigForFilters(droppedItem, a);
    }
  };
  const renderMetricsConfigComponent = (droppedItem) => {
    // console.log(droppedItem);

    setMetricConfigContent(
      <MetricConfigComponent
        {...{
          reduxKey,
          parentKey,
          Sheetid,
          droppedItem,
          handleClosePopup,
          handleSavePopupMetric,
          alreadyExists: false,
          VizchartType,
        }}
      />
    );
  };
  const renderDateConfigComponentForRows = (droppedItem, index) => {
    setDateConfigContent(
      <DateComponent
        {...{
          reduxKey,
          parentKey,
          Sheetid,
          dataSourceID,
          droppedItem,
          handleClosePopup,
          handleSavePopupDate,
          alreadyExists: false,
          index,
          // setModalData,
        }}
      />
    );
  };
  const renderDateComponentsForFilters = (droppedItem) => {
    setFilterFieldModal(
      <FilterFieldComp
        settingFunction={handleFilterFieldSave}
        setFilterFieldModal={setFilterFieldModal}
        droppedItem={droppedItem}
      />
    );
  };
  const renderNumberFormatComponent = (droppedItem) => {
    setNoFormattModal(
      <NoformatModalDrop
        closeModal={() => setNoFormattModal(false)}
        reduxKey={reduxKey}
        Sheetid={Sheetid}
        itemForNumFormat={droppedItem}
        dispatchUpdateItem={dispatchUpdateItem}
      />
    );
  };
  const handleNumberFormat = (data) => {
    // console.log(data);
    renderNumberFormatComponent(data);
  };

  const handleGeogrophy = (data) => {
    renderNumberGeogrophyMappingComponent(data);
  };
  const renderNumberGeogrophyMappingComponent = (droppedItem) => {
    setNoFormattModal(
      <AreaMapping
        closeModal={() => setNoFormattModal(false)}
        reduxKey={reduxKey}
        Sheetid={Sheetid}
        fieldForGeogrophy={droppedItem}
        dispatchUpdateItem={dispatchUpdateItem}
        dataSourceID={dataSourceID}
      />
    );
  };
  const hierarchy =
    useSelector((state) => getWorkbookProperty(state, "hierarchy")) || {};

  const [{ canDrop }, dropref] = useDrop({
    accept: "Data",
    drop: (item, monitor) => {
      const droppedItem = monitor.getItem();
      droppedItemRef.current = droppedItem;
      const isValidMove =
        droppedItem.reduxKey &&
        droppedItem.reduxKey !== reduxKey &&
        ["rows", "groupByFields"].includes(droppedItem.reduxKey) &&
        ["rows", "groupByFields"].includes(reduxKey);

      if (isValidMove) {
        // console.log(
        //   `${droppedItem.columnName} is moved from ${droppedItem.reduxKey} to ${reduxKey}`
        // );
        dispatch(
          moveDroppedColumn({
            fromReduxKey: droppedItem.reduxKey,
            toReduxKey: reduxKey,
            droppedItem,
            Sheetid,
          })
        );
      } else {
        switch (reduxKey) {
          case "rows":
            if (droppedItem.dataType === "Date") {
              const dateDroppedItem = {
                ...droppedItem,
                nanoId: droppedItem.nanoId ?? nanoid(),
                reduxKey,
              };
              const droppedItemIsAlreadyPresent = requiredArray.findIndex(
                (rItem) => rItem.nanoId === droppedItem.nanoId
              );
              if (droppedItemIsAlreadyPresent >= 0) {
                // item is already present in array so can't dispatch again
              } else {
                renderDateConfigComponentForRows(dateDroppedItem);
              }
            } else if (droppedItem.dataType === "Hierarchy") {
              const foundHierachy = hierarchy.find(
                (item) => item.hierarchyColumn.uuid === droppedItem.uuid
              );
              // console.log(foundHierachy);
              if (foundHierachy && foundHierachy.hierarchyArray.length) {
                const updatedHierarchyWithReduxKey =
                  foundHierachy.hierarchyArray.map((hAItem) => {
                    return { ...hAItem, reduxKey };
                  });
                const firstHeirarchyItem = updatedHierarchyWithReduxKey[0];
                // console.log({ ...firstHeirarchyItem });
                dispatchItemToredux({ ...firstHeirarchyItem });
              } else {
                console.error(
                  "Hierarchy or hierarchyArray1 is not found or is empty"
                );
              }
            } else if (droppedItem.columnType === "calculatedField") {
              const calculatedColumn = calculatedFields.find(
                (cItem) => cItem.uuid === droppedItem.uuid
              );
              // console.log(calculatedColumn.rename);
              dispatchItemToredux({
                ...droppedItem,
                formula: calculatedColumn.formula,
                reduxKey,
              });
            } else {
              let currentlyDroppedItem = {
                ...droppedItem,
                nanoId: droppedItem.nanoId ?? nanoid(),
                reduxKey,
              };
              const foundHierachy = hierarchy.find((item) =>
                item.hierarchyArray.find(
                  (hAItem) => hAItem.uuid === currentlyDroppedItem.uuid
                )
              );
              // console.log(foundHierachy);

              if (foundHierachy && foundHierachy.hierarchyArray.length) {
                const hierarchyArrayItem = foundHierachy.hierarchyArray.find(
                  (hAItem) => hAItem.uuid === currentlyDroppedItem.uuid
                );
                currentlyDroppedItem = hierarchyArrayItem;
                // console.log(currentlyDroppedItem);
                dispatchItemToredux(currentlyDroppedItem);
              } else {
                // console.log(
                //   `no hierarchy found for ${currentlyDroppedItem.columnName}`
                // );
                const droppedItemIsAlreadyPresent = requiredArray.findIndex(
                  (rItem) => rItem.nanoId === droppedItem.nanoId
                );
                if (droppedItemIsAlreadyPresent >= 0) {
                  // item is already present in array so can't dispatch again
                } else {
                  dispatchItemToredux({
                    ...currentlyDroppedItem,
                    nanoId: droppedItem.nanoId ?? nanoid(),
                    reduxKey,
                  });
                }
              }
            }
            break;
          case "groupByFields":
            if (droppedItem.dataType === "Date") {
              const dateDroppedItem = {
                ...droppedItem,
                nanoId: droppedItem.nanoId ?? nanoid(),
                reduxKey,
              };
              const droppedItemIsAlreadyPresent = requiredArray.findIndex(
                (rItem) => rItem.nanoId === droppedItem.nanoId
              );
              if (droppedItemIsAlreadyPresent >= 0) {
                // item is already present in array so can't dispatch again
              } else {
                renderDateConfigComponentForRows(dateDroppedItem);
              }
            } else if (droppedItem.dataType === "Hierarchy") {
              const foundHierachy = hierarchy.find(
                (item) => item.hierarchyColumn.uuid === droppedItem.uuid
              );
              // console.log(foundHierachy);
              if (foundHierachy && foundHierachy.hierarchyArray.length) {
                const updatedHierarchyWithReduxKey =
                  foundHierachy.hierarchyArray.map((hAItem) => {
                    return { ...hAItem, reduxKey };
                  });
                const firstHeirarchyItem = updatedHierarchyWithReduxKey[0];
                // console.log({ ...firstHeirarchyItem });
                dispatchItemToredux({ ...firstHeirarchyItem });
              } else {
                console.error(
                  "Hierarchy or hierarchyArray1 is not found or is empty"
                );
              }
            } else if (droppedItem.columnType === "calculatedField") {
              const calculatedColumn = calculatedFields.find(
                (cItem) => cItem.uuid === droppedItem.uuid
              );
              // console.log(calculatedColumn.rename);
              dispatchItemToredux({
                ...droppedItem,
                formula: calculatedColumn.formula,
              });
            } else {
              let currentlyDroppedItem = {
                ...droppedItem,
                nanoId: droppedItem.nanoId ?? nanoid(),
                reduxKey,
              };
              const foundHierachy = hierarchy.find((item) =>
                item.hierarchyArray.find(
                  (hAItem) => hAItem.uuid === currentlyDroppedItem.uuid
                )
              );
              // console.log(foundHierachy);

              if (foundHierachy && foundHierachy.hierarchyArray.length) {
                const hierarchyArrayItem = foundHierachy.hierarchyArray.find(
                  (hAItem) => hAItem.uuid === currentlyDroppedItem.uuid
                );
                currentlyDroppedItem = hierarchyArrayItem;
                // console.log(currentlyDroppedItem);
                dispatchItemToredux(currentlyDroppedItem);
              } else {
                // console.log(
                //   `no hierarchy found for ${currentlyDroppedItem.columnName}`
                // );
                const droppedItemIsAlreadyPresent = requiredArray.findIndex(
                  (rItem) => rItem.nanoId === droppedItem.nanoId
                );
                if (droppedItemIsAlreadyPresent >= 0) {
                  // item is already present in array so can't dispatch again
                } else {
                  dispatchItemToredux({
                    ...currentlyDroppedItem,
                    nanoId: droppedItem.nanoId ?? nanoid(),
                    reduxKey,
                  });
                }
              }
            }
            break;
          case "valueColumns":
            let valueColumn = {
              ...droppedItem,
              measure: {
                label: "Sum",
                value: "SUM",
              },
              numberObject: {
                decimalPlaces: 2,
                factor: 1,
                prefix: "$",
                sufix: "M",
                mode: "Auto",
              },
              display: "bar",
              nanoId: droppedItem.nanoId ?? nanoid(),
            };
            if (droppedItem?.columnType === "calculatedField") {
              // console.log("ji");

              const calculatedColumn = calculatedFields.find(
                (cItem) => cItem.uuid === valueColumn.uuid
              );
              // console.log(calculatedColumn.rename);
              valueColumn = {
                ...valueColumn,
                formula: calculatedColumn.formula,
              };
            } else if (droppedItem.dataType === "Number") {
              valueColumn = valueColumn;
            } else if (droppedItem.dataType === "String") {
              valueColumn = {
                ...droppedItem,
                numberObject: {
                  decimalPlaces: 2,
                  factor: 1,
                  prefix: "$",
                  sufix: "M",
                  mode: "Auto",
                },
                measure: {
                  label: "Count",
                  value: "COUNT",
                },
                nanoId: droppedItem.nanoId ?? nanoid(),
              };
            } else if (droppedItem.dataType === "Date") {
              renderDateConfigComponentForRows({
                ...droppedItem,
                nanoId: droppedItem.nanoId ?? nanoid(),
                reduxKey,
              });
            } else if (
              viztype === "areamap" &&
              Array.isArray(customization["conditionalFormatting"]) &&
              customization["conditionalFormatting"].length === 0
            ) {
              let conditionalFormattingItem = {
                columnName: droppedItem.columnName,
                rename: droppedItem.rename,
                measure: {
                  label: "Sum",
                  value: "SUM",
                },
                colorWillApplyOn: "toArea",
                isColorScaleAuto: true,
                rulesArray: [],
                formattingModalWas: "Auto",
                isColorInverted: false,
                colorScale: "schemeRdYlGn",
                columnNanoId: valueColumn.nanoId,
              };
              // console.log(conditionalFormattingItem);
              dispatch(
                setLevel2Properties({
                  reduxKey: "conditionalFormatting",
                  Sheetid,
                  parentKey: "customization",
                  value: conditionalFormattingItem,
                  itemInArray: true,
                })
              );
            }
            // console.log(valueColumn);
            const droppedItemIsAlreadyPresent = requiredArray.findIndex(
              (rItem) => rItem.nanoId === valueColumn.nanoId
            );
            if (droppedItemIsAlreadyPresent >= 0) {
              // item is already present in array so can't dispatch again
            } else {
              // console.log(valueColumn);
              if (valueColumn) {
                handleSavePopupMetric(valueColumn);
              }
            }
            break;
          case "filters":
            // console.log(droppedItem);
            const droppedFilterItemIsAlreadyPresent = requiredArray.findIndex(
              (rItem) => rItem.nanoId === droppedItem.nanoId
            );
            if (droppedFilterItemIsAlreadyPresent >= 0) {
              // item is already present in array so can't dispatch again
            } else {
              if (droppedItem.dataType === "Date") {
                renderDateComponentsForFilters(droppedItem);
              } else if (droppedItem.columnType === "calculatedField") {
                const calculatedColumn = calculatedFields.find(
                  (cItem) => cItem.uuid === droppedItem.uuid
                );
                // console.log(calculatedColumn.rename);
                renderFilterConfigComponent({
                  ...droppedItem,
                  formula: calculatedColumn.formula,
                });
              } else {
                renderFilterConfigComponent(droppedItem);
              }
            }
            break;
          case "tooltip":
            // console.log(droppedItem);
            const droppedTooltipItemIsAlreadyPresent = requiredArray.findIndex(
              (rItem) => rItem.nanoId === droppedItem.nanoId
            );
            if (droppedTooltipItemIsAlreadyPresent >= 0) {
              // item is already present in array so can't dispatch again
            } else {
              renderMetricsConfigComponent(droppedItem);
            }
            break;
          default:
            // console.log("invalid redux key", reduxKey);
        }
      }
    },
    canDrop: (item, monitor) => {
      let correctDataType = true;
      let correctLength = true;
      if (dataTypeAllowed !== "all") {
        if (item.dataType.toLowerCase() !== dataTypeAllowed) {
          correctDataType = false;
        }
      }
      if (Array.isArray(requiredArray) && requiredArray.length && single) {
        correctLength = false;
      }
      return correctDataType && correctLength;
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const handleRemoveItem = (value) => {
    // // console.log(value);
    if (reduxKey === "filters") {
      // console.log(reduxKey);
      // console.log(value);
      dispatch(
        setCommonFilters({
          operation: "REMOVE",
          value,
          Sheetid,
        })
      );
    } else {
      // console.log(reduxKey);
      dispatch(
        removeLevel2PropertiesBynanoId({
          reduxKey,
          Sheetid,
          parentKey,
          value,
          itemInArray,
          hierarchy,
          viztype,
        })
      );
    }
  };

  const handleEdit = (data, index) => {
    // console.log(data);
    // console.log(index);
    // console.log(reduxKey);

    switch (reduxKey) {
      case "valueColumns":
        if (data.dataType === "Number" || data.dataType === "String") {
          renderMetricsConfigComponent(data);
        } else if (data.dataType === "Date") {
          renderDateConfigComponentForRows(data, index);
        }
        break;
      case "filters":
        // console.log(data);
        if (data.dataType === "Date" && data.isRelativeDate) {
          // console.log("hi");
          renderDateConfigForFilters(data);
        } else {
          renderFilterConfigComponent(data);
        }
        break;
      case "tooltip":
        renderMetricsConfigComponent(data);
        break;
      default:
        // console.log("inValid redux key", reduxKey);
    }
  };
  const handleDate = (data, index) => {
    renderDateConfigComponentForRows(data, index);
  };
  const handleLimitChange = (e) => {
    dispatchItemToredux(e.target.value);
  };

  const dropFieldOrClickHereIsTrue = [
    "rows",
    "groupByFields",
    "valueColumns",
  ].includes(reduxKey);

  const DropZoneContent = (type) => {
    switch (type) {
      case "dropzone":
        return (
          <div className="flex flex-col items-center justify-center w-full gap-2 ">
            <h1 className="text-m w-full px-2 text-gray-600 font-medium text-left">
              {title}
            </h1>
            <div
              ref={dropref}
              className={`w-[95%] rounded h-full gap-[2px] pt-[1px] pb-[0px] border border-gray-300 flex flex-col items-center justify-center truncate`}
            >
              {filterConfigContent}
              {MetricConfigContent}
              {dateConfigContent}
              {noFormattModal}
              {filterFieldModal}
              {Array.isArray(requiredArray) &&
                requiredArray.map((data, index) => (
                  <DroppedData
                    key={index}
                    handleDate={handleDate}
                    handleEdit={handleEdit}
                    handleRemoveItem={handleRemoveItem}
                    data={data}
                    viztype={viztype}
                    reduxKey={reduxKey}
                    dispatchCommonFilters={dispatchCommonFilters}
                    handleNumberFormat={(data) => {
                      handleNumberFormat(data)
                    }}
                    handleGeogrophy={handleGeogrophy}
                    Sheetid={Sheetid}
                    index={index}
                    dispatchItemToredux={dispatchItemToredux}
                    dispatchUpdateItem={dispatchUpdateItem}
                    dataSourceID={dataSourceID}
                    requiredArray={requiredArray}
                  />
                ))}
              <div className="w-full px-2 py-0 dropFieldHere ">
                {requiredArray.length === 0 ? (
                  <DropFieldHere
                    dropFieldName={
                      dropFieldOrClickHereIsTrue
                        ? "Drop field here or click"
                        : "Drop field here"
                    }
                    title={title}
                    reduxKey={reduxKey}
                    dataTypeAllowed={dataTypeAllowed}
                    dataSourceID={dataSourceID}
                    dispatchItemToredux={dispatchItemToredux}
                    canDrop={canDrop}
                    dropFieldOrClickHereIsTrue={dropFieldOrClickHereIsTrue}
                  />
                ) : single ? null : (
                  <DropFieldHere
                    dropFieldName={
                      dropFieldOrClickHereIsTrue
                        ? "Drop field here or click"
                        : "Drop field here"
                    }
                    title={title}
                    reduxKey={reduxKey}
                    dataTypeAllowed={dataTypeAllowed}
                    dataSourceID={dataSourceID}
                    dispatchItemToredux={dispatchItemToredux}
                    canDrop={canDrop}
                    dropFieldOrClickHereIsTrue={dropFieldOrClickHereIsTrue}
                  />
                )}
              </div>
            </div>
          </div>
        );
      case "dropdown":
        if (canEdit) {
          return (
            <Type_n_Select
              title={title}
              reduxKey={reduxKey}
              optionsArray={limitOptions}
              onChange={handleLimitChange}
              value={rowLimit || 500}
              isArrayBig={limitOptions.length > 6}
              inputType="Number"
            />
          );
        }
      default:
        break;
    }
  };

  return <>{DropZoneContent(type)}</>;
};

export default DropZoneComp;
